import { appBottomClearanceClass } from "@/components/common/appBottomClearance";
import { AuthHeader } from "@/features/auth/components/AuthHeader";
import { cn } from "@/lib/utils";
import { AuthCard } from "./AuthCard";

interface AuthLayoutProps {
    children: React.ReactNode;
    /** Card width variant passed through to AuthCard when using card wrapper mode. */
    cardVariant?: "default" | "wide" | "extraWide";
    /** When true, children are rendered inside AuthCard; when false, children manage their own card. */
    wrapInCard?: boolean;
    className?: string;
}

export function AuthLayout({ children, cardVariant = "default", wrapInCard = true, className }: AuthLayoutProps) {
    return (
        <div className={cn("flex flex-col dark:bg-muted/25 w-full min-h-[100dvh]", appBottomClearanceClass, className)}>
            <AuthHeader />
            <div className="flex flex-col flex-1 justify-center md:px-4 md:py-10 lg:py-12">
                <div
                    className={cn(
                        "flex flex-col gap-8 mx-auto w-full",
                        cardVariant === "extraWide"
                            ? "max-w-5xl"
                            : cardVariant === "wide"
                              ? "max-w-3xl"
                              : "max-w-[560px]"
                    )}
                >
                    {wrapInCard ? <AuthCard variant={cardVariant}>{children}</AuthCard> : children}
                </div>
            </div>
        </div>
    );
}
